// EkBharatShreshthaBharat
import React from 'react';
import EkBharat2023 from 'views/EkBharat2023';

const EkBharatShreshthaBharatPage = () => {
  return <EkBharat2023 />;
};

export default EkBharatShreshthaBharatPage;